export const getInitials = (fullName: string): string => {
  if (!fullName) return ''
  const [first, last] = fullName.split(' ')
  return `${first.charAt(0)}${last ? last.charAt(0) : first.charAt(1)}`.toUpperCase()
}
